import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

export default ({
  color = defaultIconColor,
  hasChildren,
  hasSibling,
}: SVGComponentPropsType & {
  hasChildren?: boolean;
  hasSibling?: boolean;
}) => {
  const lineStroke = color;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" x2="1" y2="3" stroke={lineStroke} strokeWidth="2" />
      <path
        d="M10 12C8.8181 12 7.64778 11.7672 6.55585 11.3149C5.46392 10.8626 4.47177 10.1997 3.63604 9.36396C2.80031 8.52823 2.13738 7.53608 1.68508 6.44415C1.23279 5.35222 1 4.1819 1 3"
        stroke={lineStroke}
        strokeWidth="2"
      />
      {hasSibling && <line x1="1" x2="1" y1="3" y2="24" stroke={lineStroke} strokeWidth="2" />}
      <rect x="11" y="7" width="10" height="10" rx="3" fill="white" stroke={color} strokeWidth="2" />
      {hasChildren && <line x1="16" y1="18" x2="16" y2="24" stroke={lineStroke} strokeWidth="2" />}
    </svg>
  );
};
